module.exports = __webpack_public_path__ + "static/media/valid.abd16d44.svg";